export enum PayFrequencyOptionLabel {
  Weekly = 'Weekly',
  BiWeekly = 'Bi-weekly',
  SemiMonthly = 'Semi-monthly',
  Monthly = 'Monthly',
}

export enum PayFrequencyOptionValue {
  Weekly = 'weekly', // every week
  BiWeekly = 'biweekly', // every other week
  SemiMonthly = 'semimonthly', // twice a month
  Monthly = 'monthly', // every month
}

export const PayFrequencyValueToLabel: Record<PayFrequencyOptionValue, PayFrequencyOptionLabel> = {
  [PayFrequencyOptionValue.Weekly]: PayFrequencyOptionLabel.Weekly,
  [PayFrequencyOptionValue.BiWeekly]: PayFrequencyOptionLabel.BiWeekly,
  [PayFrequencyOptionValue.SemiMonthly]: PayFrequencyOptionLabel.SemiMonthly,
  [PayFrequencyOptionValue.Monthly]: PayFrequencyOptionLabel.Monthly,
};

export interface YourIncomeResponse {
  employmentIncome: Record<string, string>[];
}
